import {Component, OnInit} from '@angular/core';
import {Params, ActivatedRoute, Router} from "@angular/router";
import {LoaderService} from "../../../services/loader.service";
import {AlertService} from "../../../services/alert.service";
import {AccountBookingService} from "../../../services/account-booking.service";
import {PrintService} from "../../../services/print.service";
import * as $ from 'jquery';
import * as moment from 'moment';
import {Validators, FormBuilder, FormGroup, FormControl} from "@angular/forms";
import {AccountsService} from "../../../services/accounts.service";
import {SettingsService} from "../../../services/settings.service";


@Component({
  selector: 'app-account-booking-print',
  templateUrl: './account-booking-print.component.html',
  styleUrls: ['./account-booking-print.component.css']
})
export class AccountBookingPrintComponent implements OnInit {
  id;
  accountBookFormObject = [];
  pageSize = 'A4';
  byDay = [];
  byweek = [];
  bymonth = [];
  total_net_amount = 0;
  account_booking_print;
  today;
  firmData = {};
  accountList = [];
  showGSTIN = false;


  constructor(private accountBookingService:AccountBookingService,
              private alertService:AlertService,
              private printService:PrintService,
              private settingsService:SettingsService,
              private loaderService:LoaderService,
              private accountsService:AccountsService,
              private route:ActivatedRoute,
              private router:Router,
              private formBuilder:FormBuilder) {
  }

  ngOnInit() {
    this.today = new Date().getTime();
    this.route.queryParams.forEach((params:Params) => {
      this.id = params['id'];
    });

    this.account_booking_print = this.formBuilder.group({
      account: ['', Validators.required],
      start_date: ['', Validators.required],
      sdate: [''],
      edate: [''],
      end_date: ['', Validators.required]
    });
    this.id ? this.account_booking_print.patchValue({account: this.id}) : null;

    this.accountsService
      .list()
      .subscribe(
        data => {
          this.accountList = data;
        },
        error => {
          this.alertService.error(error);
          this.loaderService.loading(false);
        });

    $('#sdate').datetimepicker({
      format: 'DD/MM/YYYY'
    });
    $('#sdate').on('dp.change', (ev) => {
      this.account_booking_print.patchValue({start_date: new Date(ev.date.toDate()).getTime()});
      $('#edate').data("DateTimePicker").minDate(ev.date);
    });
    $('#sdate').on('blur', (ev) => {
      !(<HTMLInputElement>ev.currentTarget).value ? this.account_booking_print.patchValue({start_date: null}) : null;
    });
    $('#edate').datetimepicker({
      format: 'DD/MM/YYYY'
    });
    $('#edate').on('dp.change', (ev) => {
      this.account_booking_print.patchValue({end_date: new Date(ev.date.toDate()).getTime()});
      $('#sdate').data("DateTimePicker").maxDate(ev.date);
    });
    $('#edate').on('blur', (ev) => {
      !(<HTMLInputElement>ev.currentTarget).value ? this.account_booking_print.patchValue({end_date: null}) : null;
    });
    this.getFirmData();
  }

  validateAllFormFields(formGroup:FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
    $(document).ready(function () {
      $('html, body').animate({
        scrollTop: $('.alert-danger').closest('.form-group').offset().top - 56
      }, 500);
    });
  }

  getFirmData() {
    this.loaderService.loading(true);
    this.settingsService.firmDetails().subscribe(
      data => {
        data.length ? this.firmData = data[0] : null;
        this.loaderService.loading(false);
      },
      error => {
        this.alertService.error(error);
        this.loaderService.loading(false);
      });
  }

  searchAccountBookings() {
    //noinspection TypeScriptUnresolvedFunction
    this.account_booking_print.valid ? this.accountBookingService.getUnPaidRecord({
      id: this.account_booking_print.controls['account'].value,
      start_date: new Date(this.account_booking_print.controls['start_date'].value).setHours(0, 0, 0, 0) - 1,
      end_date: moment(new Date(this.account_booking_print.controls['end_date'].value).setHours(0, 0, 0, 0)).add(1, 'days').toDate().getTime()
    }).subscribe(
      data => {
        this.total_net_amount = 0;
        this.accountBookFormObject = data || [];
        data.forEach(d=> {
          this.total_net_amount += d.pending_amount;
        });
        this.groupday(data);
        this.loaderService.loading(false);
      },
      error => {
        this.alertService.error(error);
        this.loaderService.loading(false);
      }) : this.validateAllFormFields(this.account_booking_print);
  }

  setPageSize($event) {
    this.pageSize = $event.target.value == 'A4' ? 'A4' : 'col-xs-6';
  }

  groupday(values) {
    this.byDay = [];
    values.forEach(value=> {
      var d = Math.floor(new Date(value['booking_date']).setHours(0, 0, 0, 0) / (1000 * 60 * 60 * 24));
      var index = this.byDay.findIndex(obj=>obj.day == d);
      index < 0 ? this.byDay.push({day: d, date: new Date(value['booking_date']).getTime(), list: []}) : null;
      this.byDay[index < 0 ? this.byDay.length - 1 : index].list.push(value);
    });
    this.byDay.sort(function (a, b) {
      return parseFloat(a.day) - parseFloat(b.day);
    });
  }

  groupweek(value, index, array) {
    // var d = Math.floor(new Date(value['booking_date']).getTime() / (1000 * 60 * 60 * 24 * 7));
    // this.byweek[d] = this.byweek[d] || [];
    // this.byweek[d].push(value);
  }

  groupmonth(value, index, array) {
    // var d = (new Date(value['booking_date']).getFullYear() - 1970) * 12 + new Date(value['date']).getMonth();
    // this.bymonth[d] = this.bymonth[d] || [];
    // this.bymonth[d].push(value);
  }

  displayGSTIN($event) {
    this.showGSTIN = $event.target.checked;
  }
}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/component/account-booking/account-booking-print/account-booking-print.component.ts